import { AWS_S3_URL, customSize, EFileClassification } from 'utils/constants'
import { DOCUMENT_EXAMPLE_FILE_NAMES } from './constants'
import { getFileTypes } from '../../helpers'
import { IDocumentsExamples, IFileItem, IFileTypes } from './interface'
import { ITooltip } from 'components/FileUploader/interface'
import { TFunction } from 'i18next'

const T_ROOT = "documents"

export const getDocumentListFullPaths = (id: string): IDocumentsExamples[] =>
  DOCUMENT_EXAMPLE_FILE_NAMES[id].map((file: string) => ({
    id: file,
    src: `${AWS_S3_URL}/docs/${file}`
  }))

export const getFileTypesEntensions = (data: Array<any>): IFileTypes => {
  let fileTypesAccepted: IFileTypes = {}
  data.forEach(({ extension, mimeType }: { extension: string; mimeType: string }) => {
    fileTypesAccepted = { ...fileTypesAccepted, [mimeType]: [`.${extension}`] }
  })
  return fileTypesAccepted
}

export const getCustomMaxSize = (documentId: string, size: number): number => {
  if (
    documentId === EFileClassification.officialIDFront ||
    documentId === EFileClassification.officialIDBack ||
    documentId === EFileClassification.PROOF_OF_TAX_IDENTIFICATION
  ) {
    return customSize
  }

  return size
}

export const getFileProps = (
  fileMaxSizeAllowed: number,
  file: IFileItem,
  fileTypes: IFileTypes,
  hasInternationalDoc: boolean,
  hasKycProblem: boolean,
  t: TFunction
): {
  disabled: boolean
  file_types: IFileTypes
  maxSize: number
  tooltip?: ITooltip
} => {
  const { fileClassificationId: id, title } = file
  const tooltip =
    id === EFileClassification.proofOfAddress
      ? ({
          title: t(`${T_ROOT}.documents.${title}.title`),
          description: t(`${T_ROOT}.documents.${title}.description`)
        } as ITooltip)
      : undefined
  const disabled = (hasInternationalDoc && id === EFileClassification.officialIDBack) || hasKycProblem

  return {
    disabled,
    file_types: getFileTypes(id, fileTypes),
    maxSize: getCustomMaxSize(id, fileMaxSizeAllowed),
    tooltip
  }
}
